import requestAction from '../../utils/requestAction'

export const deletePreorderDetail = (preorderDetailId: number) =>
  requestAction('PREORDER_DETAIL_DELETE')(
    `preorderDetails/${preorderDetailId}`,
    'DELETE')

export const deleteAllPreorderDetail = (preorderId: number) =>
  requestAction('PREORDER_DETAIL_DELETE')(
    `preorderDetails/all/${preorderId}`,
    'DELETE')
